import React from 'react';

import { Tooltip as MUITooltip } from '@mui/material';

import { ColorSAP, FONT_FAMILY, Typography } from '../../ontego-ui';
import Styled from './TooltipStyles';
import { arrowGenerator } from './ArrowGenerator';


export const Tooltip = (props) => {
    const { enterNextDelay, leaveDelay } = props;

    return (
        <MUITooltip
            arrow
            {...props}
            slots={{
                tooltip: Styled.Tooltip,
                arrow: Styled.Arrow,
            }}
            title={
                <React.Fragment>
                    <Typography
                        fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR}
                        size={14}
                        color={ColorSAP.neutral[0]}
                    >
                        {props.title}
                    </Typography>
                    {props?.subTitle}
                </React.Fragment>
            }
            enterNextDelay={enterNextDelay}
            leaveDelay={leaveDelay}
        />
    );
}

export default Tooltip